import { useMemo } from "react";
import { formatQuery, RuleGroupType } from "react-querybuilder";
import { useUserAttributes } from "modules/providers/user-attributes-provider";

interface IProps {
  query?: RuleGroupType | null;
}

const useQueryBuilder = ({ query }: IProps) => {
  const { userAttributeCategories, userAttributes } = useUserAttributes();
  const naturalLanguageQuery = useMemo(() => {
    if (!query) return null;
    let _query = formatQuery(query, "jsonata");
    userAttributes.forEach((userAttribute) => {
      _query = _query.replaceAll(userAttribute.id, userAttribute.name);
    });
    userAttributeCategories.forEach((userAttributeCategory) => {
      _query = _query.replaceAll(
        userAttributeCategory.id,
        userAttributeCategory.name,
      );
    });
    return _query;
  }, [query, userAttributeCategories, userAttributes]);

  const mongoDbQuery = useMemo(() => {
    if (!query) return null;
    return JSON.stringify(formatQuery(query, "mongodb_query"));
  }, [query]);

  const serializedQuery = useMemo(() => {
    if (!query) return null;
    return JSON.stringify(query);
  }, [query]);

  return {
    naturalLanguageQuery,
    serializedQuery,
    mongoDbQuery,
  };
};

export default useQueryBuilder;
